// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-main {
  padding-top: 0 !important;
  background-color: #FFFFFF;
  background-repeat: no-repeat;
  background-position: center;
  margin: 15px !important;
}
.header-main .row > div {
  text-align: center;
  color: #694779;
}
.header-main .row > div.h-txt {
  padding-top: 12px;
  text-transform: uppercase;
}
.header-main .row > div.h-txt span {
  cursor: pointer;
}
.header-main .quote_modal .Modal .modal-content {
  border-radius: 0px !important;
}

.header-main-light {
  background-color: white;
}

.header-right {
  margin-right: 15px;
}

.header-root {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 80px;
  width: 100%;
  max-width: 1440px;
  margin: auto;
}

.theme-light {
  color: white;
}
.theme-light:hover {
  color: white;
}

.theme-dark {
  color: #000;
}
.theme-dark:hover {
  color: #000;
}

.ab1-nav-links {
  text-transform: uppercase;
  font-style: normal;
  font-weight: 600;
  font-size: clamp(14px, 1.4vw, 16px);
  letter-spacing: 0.05em;
  margin: 0 clamp(15px, 1.5vw, 20px);
  cursor: pointer;
}
.ab1-nav-links:hover {
  text-decoration: none;
}

.brand-logo {
  margin: 20px 31px;
}

#mobile-menulist {
  display: none;
}

.mobile-header-sections {
  display: none;
}

.nav-grp {
  position: relative;
  left: 5%;
}

.h-container {
  display: flex;
}

.h-container div {
  float: left;
}

header {
  height: 100px;
  background: #fff;
  display: grid;
}

nav {
  padding: 5px;
  height: 100% !important;
}

.leftp,
.rightp {
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 38px;
  align-items: center;
  letter-spacing: 0.03em;
  color: #694779;
  width: 35%;
}

/*
.leftp {
  text-align: left;
}

.rightp {
  text-align: right;
}
*/
.logotext {
  font-style: normal;
  font-weight: 600;
  font-size: 30px;
  align-items: center;
  color: #694779;
  line-height: 33px;
}

nav ul {
  list-style: none;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  padding-left: 0;
  margin-top: revert;
  height: 38px !important;
}

nav li {
  list-style: none;
  height: 100%;
}

li.middlep {
  text-align: center;
}

.middleCtr img {
  float: left;
  display: block;
}

.leftp span {
  display: flex;
  float: left;
}

.leftp span:nth-child(1) {
  margin-left: 50px;
}

.leftp span:nth-child(2) {
  margin-left: 25px;
}

#header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 30px;
}

#header .logo {
  width: 100px;
}

#header .logo img {
  display: block;
  width: 100%;
  object-fit: cover;
}

#header .menus {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 30px;
  margin: 0;
  padding: 0;
}

#header .menus li {
  list-style: none;
}

#header .menus li a {
  text-decoration: none;
  color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 7px;
}

#header .hamburger {
  cursor: pointer;
}

@media screen and (max-width: 451px) {
  .mobile-header-sections {
    display: flex;
    align-items: center;
  }
  .header-sections {
    display: none;
  }
  .brand-logo {
    margin: 20px 30px;
  }
  .header-menu {
    margin: 25px 15px;
  }
  #mobile-menulist {
    display: none;
    background-color: #000;
    padding: 5% 20px;
    position: fixed;
    width: 100%;
    overflow-y: hidden;
    z-index: 1;
    transition: ease-in(2s);
  }
  #mobile-menulist .ab1-nav-links {
    display: block;
  }
  #mobile-menulist .grp-list {
    padding: 10px 0;
  }
  #mobile-menulist .unq-list {
    padding: 30px 0;
  }
  .leftp {
    font-size: 13px;
    width: 32%;
    line-height: 20px;
  }
  .rightp {
    width: 0% !important;
  }
  .leftp span:nth-child(1) {
    margin-left: 32px;
  }
  .leftp span:nth-child(2) {
    margin-left: 3px;
  }
  li.middlep {
    text-align: left;
    width: 68%;
  }
  .logotext {
    font-size: 26px;
  }
  .ChooseAFlight .flight-info {
    display: block !important;
  }
  .ChooseAFlight .jet-img {
    width: 100% !important;
  }
  .ChooseAFlight .jet-desc {
    color: #2c3034;
    margin: 42px auto 0 auto;
    width: 100%;
    text-align: center;
  }
}
@media screen and (min-width: 451px) and (max-width: 800px) {
  .mobile-header-sections {
    display: flex;
    align-items: center;
  }
  .header-sections {
    display: none;
  }
  .brand-logo {
    margin: 20px 30px;
  }
  .header-menu {
    margin: 25px 15px;
  }
  #mobile-menulist {
    display: none;
    background-color: #000;
    padding: 5% 20px;
    position: fixed;
    width: 100%;
    overflow-y: hidden;
    z-index: 1;
    transition: ease-in(2s);
  }
  #mobile-menulist .ab1-nav-links {
    display: block;
  }
  #mobile-menulist .grp-list {
    padding: 10px 0;
  }
  #mobile-menulist .unq-list {
    padding: 30px 0;
  }
  .leftp {
    font-size: 13px;
    width: 32%;
    line-height: 20px;
  }
  .rightp {
    width: 0% !important;
  }
  .leftp span:nth-child(1) {
    margin-left: 32px;
  }
  .leftp span:nth-child(2) {
    margin-left: 3px;
  }
  li.middlep {
    text-align: left;
    width: 68%;
  }
  .logotext {
    font-size: 26px;
  }
}
@media screen and (min-width: 800px) and (max-width: 1200px) {
  .ab1-nav-links {
    font-size: clamp(12px, 1.4vw, 14px);
    letter-spacing: 0;
    margin: 0 5px;
  }
  .nav-grp {
    left: 0;
  }
  .right-menu {
    margin-right: 30px;
  }
}
@media not screen and (max-width: 800px) {
  #mobile-menulist {
    display: none !important;
  }
}
@media screen and (max-width: 820px) {
  header {
    height: 62px;
  }
  #header .menus {
    display: none !important;
  }
  #header .logo {
    width: 61px;
    height: 59px;
    padding-top: 7px;
  }
}
@media screen and (orientation: landscape) and (max-width: 915px) {
  #header .menus {
    font-size: 8px !important;
  }
}
@media screen and (orientation: landscape) and (min-width: 916px) and (max-width: 1180px) {
  #header .menus {
    font-size: 10px !important;
  }
}
@media screen and (min-width: 830px) and (max-width: 1112px) {
  #header .menus {
    display: none;
  }
}
@media screen and (min-width: 1181px) {
  #header .menus {
    font-size: 12px !important;
  }
}
.header-menu-span-spacing {
  letter-spacing: 1.1px;
}

@media screen and (min-width: 1200px) {
  .header-menu-margin {
    position: relative;
    right: 30px;
  }
}
@media screen and (max-width: 767px) {
  .header-border-mob {
    border-bottom: 5px solid #479cbd !important;
    position: fixed;
    width: 100%;
    z-index: 2;
    top: 0px;
  }
  #header {
    padding: 0 20px;
  }
}
@media screen and (max-width: 390px) {
  .ChooseAFlight .jet-desc {
    width: 94% !important;
  }
}
@media screen and (min-width: 391px) and (max-width: 430px) {
  .ChooseAFlight .jet-desc {
    width: 91% !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/containers/ChooseAFlight/CustomThemeHeader/Header.scss","webpack://./src/containers/ChooseAFlight/themevariable.scss","webpack://./src/styles/variables.scss"],"names":[],"mappings":"AAEA;EACE,yBAAA;EACA,yBCJwB;EDMxB,4BAAA;EACA,2BAAA;EACA,uBAAA;AAFF;AAIE;EACE,kBAAA;EACA,cCVkB;ADQtB;AAII;EACE,iBAAA;EACA,yBAAA;AAFN;AAIM;EACE,eAAA;AAFR;AAQI;EACE,6BAAA;AANN;;AAeA;EACE,uBAAA;AAZF;;AAeA;EACE,kBAAA;AAZF;;AAeA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,YAAA;AAZF;;AAeA;EACE,YAAA;AAZF;AAcE;EACE,YAAA;AAZJ;;AAgBA;EACE,WE5DM;AF+CR;AAeE;EACE,WE/DI;AFkDR;;AAiBA;EACE,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mCAAA;EACA,sBAAA;EACA,kCAAA;EACA,eAAA;AAdF;AAgBE;EACE,qBAAA;AAdJ;;AAkBA;EACE,iBAAA;AAfF;;AAkBA;EACE,aAAA;AAfF;;AAkBA;EACE,aAAA;AAfF;;AAkBA;EACE,kBAAA;EACA,QAAA;AAfF;;AAmBA;EACE,aAAA;AAhBF;;AAkBA;EACE,WAAA;AAfF;;AAkBA;EACE,aAAA;EACA,gBAAA;EACA,aAAA;AAfF;;AAkBA;EACE,YAAA;EACA,uBAAA;AAfF;;AAkBA;;EAEE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,sBAAA;EACA,cAAA;EACA,UAAA;AAfF;;AAkBA;;;;;;;;CAAA;AASA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;AAfF;;AAkBA;EACE,gBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,uBAAA;AAfF;;AAkBA;EACE,gBAAA;EACA,YAAA;AAfF;;AAkBA;EAGE,kBAAA;AAjBF;;AAsBA;EACE,WAAA;EACA,cAAA;AAnBF;;AAqBA;EACE,aAAA;EACA,WAAA;AAlBF;;AAqBA;EACE,iBAAA;AAlBF;;AAqBA;EACE,iBAAA;AAlBF;;AAqBA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;AAlBF;;AAoBA;EACE,YAAA;AAjBF;;AAmBA;EACE,cAAA;EACA,WAAA;EACA,iBAAA;AAhBF;;AAkBA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;EACA,SAAA;EACA,UAAA;AAfF;;AAiBA;EACE,gBAAA;AAdF;;AAgBA;EACE,qBAAA;EACA,WAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,QAAA;AAbF;;AAeA;EACE,eAAA;AAZF;;AAeA;EACE;IACE,aAAA;IACA,mBAAA;EAZF;EAeA;IACE,aAAA;EAbF;EAgBA;IACE,iBAAA;EAdF;EAiBA;IACE,iBAAA;EAfF;EAkBA;IACE,aAAA;IACA,sBAAA;IACA,gBAAA;IAEA,eAAA;IACA,WAAA;IACA,kBAAA;IACA,UAAA;IACA,uBAAA;EAjBF;EAmBE;IACE,cAAA;EAjBJ;EAoBE;IACE,eAAA;EAlBJ;EAqBE;IACE,eAAA;EAnBJ;EAsBA;IACE,eAAA;IACA,UAAA;IACA,iBAAA;EApBF;EAsBA;IACE,oBAAA;EApBF;EAsBA;IACE,iBAAA;EApBF;EAsBA;IACE,gBAAA;EApBF;EAsBA;IACE,gBAAA;IACA,UAAA;EApBF;EAsBA;IACE,eAAA;EApBF;EAsBA;IACE,yBAAA;EApBF;EAsBA;IACE,sBAAA;EApBF;EAsBA;IACE,cAAA;IACA,wBAAA;IACA,WAAA;IACA,kBAAA;EApBF;AACF;AAuBA;EACE;IACE,aAAA;IACA,mBAAA;EArBF;EAwBA;IACE,aAAA;EAtBF;EAyBA;IACE,iBAAA;EAvBF;EA0BA;IACE,iBAAA;EAxBF;EA2BA;IACE,aAAA;IACA,sBAAA;IACA,gBAAA;IAEA,eAAA;IACA,WAAA;IACA,kBAAA;IACA,UAAA;IACA,uBAAA;EA1BF;EA4BE;IACE,cAAA;EA1BJ;EA6BE;IACE,eAAA;EA3BJ;EA8BE;IACE,eAAA;EA5BJ;EA+BA;IACE,eAAA;IACA,UAAA;IACA,iBAAA;EA7BF;EA+BA;IACE,oBAAA;EA7BF;EA+BA;IACE,iBAAA;EA7BF;EA+BA;IACE,gBAAA;EA7BF;EA+BA;IACE,gBAAA;IACA,UAAA;EA7BF;EA+BA;IACE,eAAA;EA7BF;AACF;AAgCA;EACE;IACE,mCAAA;IACA,iBAAA;IACA,aAAA;EA9BF;EAgCA;IACE,OAAA;EA9BF;EAiCA;IACE,kBAAA;EA/BF;AACF;AAkCA;EACE;IACE,wBAAA;EAhCF;AACF;AAkCA;EACE;IACE,YAAA;EAhCF;EAkCA;IACE,wBAAA;EAhCF;EAkCA;IACE,WAAA;IACA,YAAA;IACA,gBAAA;EAhCF;AACF;AAkCA;EACE;IACE,yBAAA;EAhCF;AACF;AAkCA;EACE;IACE,0BAAA;EAhCF;AACF;AAkCA;EACE;IACE,aAAA;EAhCF;AACF;AAmCA;EACE;IACE,0BAAA;EAjCF;AACF;AAmCA;EACE,qBAAA;AAjCF;;AAmCA;EACE;IACE,kBAAA;IACA,WAAA;EAhCF;AACF;AAkCA;EACE;IACE,2CAAA;IACA,eAAA;IACA,WAAA;IACA,UAAA;IACA,QAAA;EAhCF;EAkCA;IACE,eAAA;EAhCF;AACF;AAkCA;EACE;IACE,qBAAA;EAhCF;AACF;AAkCA;EACE;IACE,qBAAA;EAhCF;AACF","sourcesContent":["@use \"src/styles/variables\" as vars;\n@use \"src/containers/ChooseAFlight/themevariable.scss\" as theme;\n.header-main {\n  padding-top: 0 !important;\n  background-color: theme.$defaultBackgroundColor;\n  // background-image: url(\"../../../assets/custom-theme/header.png\");\n  background-repeat: no-repeat;\n  background-position: center;\n  margin: 15px !important;\n\n  .row > div {\n    text-align: center;\n    color: theme.$customPrimaryColor;\n\n    &.h-txt {\n      padding-top: 12px;\n      text-transform: uppercase;\n\n      span {\n        cursor: pointer;\n      }\n    }\n  }\n\n  .quote_modal {\n    .Modal .modal-content {\n      border-radius: 0px !important;\n    }\n  }\n}\n\n// .header-main-dark-auth {\n//   background-color: $black;\n// }\n\n.header-main-light {\n  background-color: white;\n}\n\n.header-right {\n  margin-right: 15px;\n}\n\n.header-root {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: 80px;\n  width: 100%;\n  max-width: 1440px;\n  margin: auto;\n}\n\n.theme-light {\n  color: white;\n\n  &:hover {\n    color: white;\n  }\n}\n\n.theme-dark {\n  color: vars.$black;\n\n  &:hover {\n    color: vars.$black;\n  }\n}\n\n.ab1-nav-links {\n  text-transform: uppercase;\n  font-style: normal;\n  font-weight: 600;\n  font-size: clamp(14px, 1.4vw, 16px);\n  letter-spacing: 0.05em;\n  margin: 0 clamp(15px, 1.5vw, 20px);\n  cursor: pointer;\n\n  &:hover {\n    text-decoration: none;\n  }\n}\n\n.brand-logo {\n  margin: 20px 31px;\n}\n\n#mobile-menulist {\n  display: none;\n}\n\n.mobile-header-sections {\n  display: none;\n}\n\n.nav-grp {\n  position: relative;\n  left: 5%;\n  // position: absolute;\n  // margin-left: -7%;\n}\n.h-container {\n  display: flex;\n}\n.h-container div {\n  float: left;\n}\n\nheader {\n  height: 100px;\n  background: #fff;\n  display: grid;\n}\n\nnav {\n  padding: 5px;\n  height: 100% !important;\n}\n\n.leftp,\n.rightp {\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 38px;\n  align-items: center;\n  letter-spacing: 0.03em;\n  color: #694779;\n  width: 35%;\n}\n\n/*\n.leftp {\n  text-align: left;\n}\n\n.rightp {\n  text-align: right;\n}\n*/\n.logotext {\n  font-style: normal;\n  font-weight: 600;\n  font-size: 30px;\n  align-items: center;\n  color: #694779;\n  line-height: 33px;\n}\n\nnav ul {\n  list-style: none;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  padding-left: 0;\n  margin-top: revert;\n  height: 38px !important;\n}\n\nnav li {\n  list-style: none;\n  height: 100%;\n}\n\nli.middlep {\n  // flex: 1;\n  // margin-left: -120px;\n  text-align: center;\n}\n.middleCtr {\n  // width : 175px\n}\n.middleCtr img {\n  float: left;\n  display: block;\n}\n.leftp span {\n  display: flex;\n  float: left;\n}\n\n.leftp span:nth-child(1) {\n  margin-left: 50px;\n}\n\n.leftp span:nth-child(2) {\n  margin-left: 25px;\n}\n\n#header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 30px;\n}\n#header .logo {\n  width: 100px;\n}\n#header .logo img {\n  display: block;\n  width: 100%;\n  object-fit: cover;\n}\n#header .menus {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 30px;\n  margin: 0;\n  padding: 0;\n}\n#header .menus li {\n  list-style: none;\n}\n#header .menus li a {\n  text-decoration: none;\n  color: #fff;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 7px;\n}\n#header .hamburger {\n  cursor: pointer;\n}\n\n@media screen and (vars.$mobile-media) {\n  .mobile-header-sections {\n    display: flex;\n    align-items: center;\n  }\n\n  .header-sections {\n    display: none;\n  }\n\n  .brand-logo {\n    margin: 20px 30px;\n  }\n\n  .header-menu {\n    margin: 25px 15px;\n  }\n\n  #mobile-menulist {\n    display: none;\n    background-color: #000;\n    padding: 5% 20px;\n    // height: 100%;\n    position: fixed;\n    width: 100%;\n    overflow-y: hidden;\n    z-index: 1;\n    transition: ease-in(2s);\n\n    .ab1-nav-links {\n      display: block;\n    }\n\n    .grp-list {\n      padding: 10px 0;\n    }\n\n    .unq-list {\n      padding: 30px 0;\n    }\n  }\n  .leftp {\n    font-size: 13px;\n    width: 32%;\n    line-height: 20px;\n  }\n  .rightp {\n    width: 0% !important;\n  }\n  .leftp span:nth-child(1) {\n    margin-left: 32px;\n  }\n  .leftp span:nth-child(2) {\n    margin-left: 3px;\n  }\n  li.middlep {\n    text-align: left;\n    width: 68%;\n  }\n  .logotext {\n    font-size: 26px;\n  }\n  .ChooseAFlight .flight-info {\n    display: block !important;\n  }\n  .ChooseAFlight .jet-img {\n    width: 100% !important;\n  }\n  .ChooseAFlight .jet-desc {\n    color: #2c3034;\n    margin: 42px auto 0 auto;\n    width: 100%;\n    text-align: center;\n  }\n}\n\n@media screen and (vars.$tablet-media-min) and (vars.$tablet-media) {\n  .mobile-header-sections {\n    display: flex;\n    align-items: center;\n  }\n\n  .header-sections {\n    display: none;\n  }\n\n  .brand-logo {\n    margin: 20px 30px;\n  }\n\n  .header-menu {\n    margin: 25px 15px;\n  }\n\n  #mobile-menulist {\n    display: none;\n    background-color: #000;\n    padding: 5% 20px;\n    // height: 100%;\n    position: fixed;\n    width: 100%;\n    overflow-y: hidden;\n    z-index: 1;\n    transition: ease-in(2s);\n\n    .ab1-nav-links {\n      display: block;\n    }\n\n    .grp-list {\n      padding: 10px 0;\n    }\n\n    .unq-list {\n      padding: 30px 0;\n    }\n  }\n  .leftp {\n    font-size: 13px;\n    width: 32%;\n    line-height: 20px;\n  }\n  .rightp {\n    width: 0% !important;\n  }\n  .leftp span:nth-child(1) {\n    margin-left: 32px;\n  }\n  .leftp span:nth-child(2) {\n    margin-left: 3px;\n  }\n  li.middlep {\n    text-align: left;\n    width: 68%;\n  }\n  .logotext {\n    font-size: 26px;\n  }\n}\n\n@media screen and (vars.$tablet-media-min-hz) and (vars.$tablet-media-hz) {\n  .ab1-nav-links {\n    font-size: clamp(12px, 1.4vw, 14px);\n    letter-spacing: 0;\n    margin: 0 5px;\n  }\n  .nav-grp {\n    left: 0;\n  }\n\n  .right-menu {\n    margin-right: 30px;\n  }\n}\n\n@media not screen and (vars.$tablet-media) {\n  #mobile-menulist {\n    display: none !important;\n  }\n}\n@media screen and (max-width: 820px) {\n  header {\n    height: 62px;\n  }\n  #header .menus {\n    display: none !important;\n  }\n  #header .logo {\n    width: 61px;\n    height: 59px;\n    padding-top: 7px;\n  }\n}\n@media screen and (orientation: landscape) and (max-width: 915px) {\n  #header .menus {\n    font-size: 8px !important;\n  }\n}\n@media screen and (orientation: landscape) and (min-width: 916px) and (max-width: 1180px) {\n  #header .menus {\n    font-size: 10px !important;\n  }\n}\n@media screen and (min-width: 830px) and (max-width: 1112px) {\n  #header .menus {\n    display: none;\n  }\n}\n\n@media screen and (min-width: 1181px) {\n  #header .menus {\n    font-size: 12px !important;\n  }\n}\n.header-menu-span-spacing {\n  letter-spacing: 1.1px;\n}\n@media screen and (min-width: 1200px) {\n  .header-menu-margin {\n    position: relative;\n    right: 30px;\n  }\n}\n@media screen and (max-width: 767px) {\n  .header-border-mob {\n    border-bottom: 5px solid #479cbd !important;\n    position: fixed;\n    width: 100%;\n    z-index: 2;\n    top: 0px;\n  }\n  #header {\n    padding: 0 20px;\n  }\n}\n@media screen and (max-width: 390px) {\n  .ChooseAFlight .jet-desc {\n    width: 94% !important;\n  }\n}\n@media screen and (min-width: 391px) and (max-width: 430px) {\n  .ChooseAFlight .jet-desc {\n    width: 91% !important;\n  }\n}\n","$defaultBackgroundColor : #FFFFFF;\n$defaultFontColor : #000000;\n$customPrimaryColor : #694779;\n$customFontColor : #FFFFFF;\n$searchPanelBackgroundColor : #F4F4F4;\n$descriptionFontColor : #2C3034;\n$customSecondaryColor : #F1F4F9;\n$listItemFeatureFontColor : #535A61;\n$conciergeButtonBackgroundColor : #B9A691;","$page-width: 968px;\n$page-short-width: 700px;\n$black: #000;\n$white: #fff;\n$yellow: #ebff0c;\n$blue: #3881ef;\n$blue1:#4782E7;\n$red: #ef3838;\n$dark-blue: #1d6add;\n$grey1: #f1f4f9;\n$grey2: #cfcdcd;\n$grey3: #848b94;\n$grey4: #d5dce7;\n$grey5: #2c3034;\n$grey6: #535a61;\n$grey7: #9ca2a9;\n$grey8: #666d74;\n\n$font-regular: 'FKGroteskNeue-Regular';\n$font-medium: 'FKGroteskNeue-Medium';\n$font-bold: 'FKGroteskNeue-Bold';\n$mobile-media: 'max-width: 451px';\n$tablet-media-min: 'min-width: 451px';\n$tablet-media: 'max-width: 800px';\n$tablet-media-min-hz: 'min-width: 800px';\n$tablet-media-hz: 'max-width: 1200px';\n\n// Guide Color Code ----------------------------------\n\n$primary-black: #000000;\n$primary-white: #FFFFFF;\n$primary-gray: #F1F4F9;\n$secondary-yellow: #EBFF0C;\n$secondary-skyblue: #3881EF;\n$secondary-darkblue: #1D6ADD;\n$light-gray1: #F1F4F9;\n$light-gray2: #D5DCE7;\n$light-gray3: #848B94;\n$dark-gray1: #2C3034;\n$dark-gray2: #535A61;\n$dark-gray3: #9CA2A9;\n$error-red: #EF3838;\n$success-green : #AAFE3F;\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
